<template>
  <div class="container-xl mt-3">
    <div class="row row-cards">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <!-- Page title -->
        <div class="page-header d-print-none mb-2">
          <div class="row align-items-center">
            <div class="col">
              <h2 class="page-title">客戶出金</h2>
            </div>
          </div>
        </div>
        <div class="row mb-4">
					<div class="col-md-8 col-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">
                    可撥款金額
                  </h3>
                </div>
                <div class="card-body">
									<div class="row">
										<div class="col-6">
											<div class="row">
												<div class="col-md-2">
													<span
														class="avatar"
														:style="{
															background: '#fff center/cover',
															backgroundImage:
																'url(\'' +
																require('../assets/images/eth-logo.png') +
																'\')',
																width: '30px',
																height: '30px'
														}"
													></span>
												</div>
												<div class="col-md-3">
													<h3 class="mb-0">數量</h3>
												</div>
												<div class="col-md-7">
													<h3 class="mb-0">
							{{ ethereumUSDTremainBalance }}
													</h3>
												</div>
											</div>
										</div>
										<div class="col-6">
											<div class="row">
												<div class="col-md-2">
													<span
														class="avatar"
														:style="{
															background: '#fff center/cover',
															backgroundImage:
																'url(\'' +
																require('../assets/images/tron-logo.png') +
																'\')',
															width: '30px',
															height: '30px'
														}"
													></span>
												</div>
												<div class="col-md-3">
													<h3 class="mb-0">數量</h3>
												</div>
												<div class="col-md-7">
													<h3 class="mb-0">
							{{ tronUSDTremainBalance }}
													</h3>
												</div>
											</div>
										</div>
                  </div>
                </div>
              </div>
					</div>
					<div class="col-md-4 col-12">
						<div class="card">
              <div class="card-header">
                <h3 class="card-title">設定</h3>
              </div>
              <div class="card-body">
                <div
                  :class="
                    alertStatus === 'success'
                      ? 'alert alert-success'
                      : 'alert alert-danger'
                  "
                  v-show="alertStatus !== ''"
                  role="alert"
                >
                  {{ alertMsg }}
                </div>
                <div class="row mb-1 mt-1 g-2 align-items-center">
                  <div class="col-md-6">出金錢包設定</div>
                  <div class="col-md-6">
                    <router-link
                      to="disperseWalletAddressSetting"
                      class="btn btn-outline-info w-100"
                      >設定
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
					</div>
        </div>
				<div class="row">
					<div class="col-lg-12 overflow-auto">
						<div class="row row-cards">
							<div class="col-12">
								<div class="card">
									<div class="card-body border-bottom py-3">
										<div class="d-flex">
											<div class="text-muted">
												每頁
												<div class="mx-2 d-inline-block">
													<input
														type="number"
														class="form-control form-control-sm"
														v-model.number="size"
														size="3"
														v-on:change="changeSize()"
													/>
												</div>
												筆
											</div>
											<!--<div class="ml-auto text-muted">
												搜尋:
												<div class="ml-2 d-inline-block">
													<input type="text" class="form-control form-control-sm" />
												</div>
											</div>-->
										</div>
									</div>
									<div class="table-responsive">
										<table class="table card-table table-vcenter text-nowrap datatable">
											<thead>
												<tr>
													<th class="w-1">
														交易序號
														<svg
															xmlns="http://www.w3.org/2000/svg"
															class="icon icon-sm text-dark icon-thick"
															width="24"
															height="24"
															viewBox="0 0 24 24"
															stroke-width="2"
															stroke="currentColor"
															fill="none"
															stroke-linecap="round"
															stroke-linejoin="round"
														>
															<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
															<polyline points="6 15 12 9 18 15"></polyline>
														</svg>
													</th>
													<th>商店提供客戶編號</th>
													<th>公鏈</th>
													<th>幣種</th>
													<th>地址</th>
                          <th>金額</th>
                          <th>註記</th>
                          <th>狀態</th>
                          <th>創建時間</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in withdrawalList" :key="item.id">
													<td>
														<span class="text-muted">{{ item.id }}</span>
													</td>
													<td>
														<span class="text-muted">{{
															item.merchantCustomizeId
														}}</span>
													</td>
													<td>
                            <span
                              v-if="item.chain === 'tron'"
                              class="avatar"
                              :style="{
                                background: '#fff center/cover',
                                backgroundImage:
                                  'url(\'' +
                                  require('../assets/images/tron-logo.png') +
                                  '\')',
                                width: '15px',
                                height: '15px'
                              }"
                            ></span>
                            <span
                              v-else-if="item.chain == 'ethereum'"
                              class="avatar"
                              :style="{
                                background: '#fff center/cover',
                                backgroundImage:
                                  'url(\'' +
                                  require('../assets/images/eth-logo.png') +
                                  '\')',
                                width: '15px',
                                height: '15px'
                              }"
                            ></span>
													</td>
                          <td>
														{{ item.currency }}
													</td>
                          <td>
														{{ item.address }}
													</td>
                          <td>
                            {{
                              item.amount.substring(
                                0,
                                item.amount.indexOf(".") + 3
                              )
                            }}
													</td>
                          <td>
														{{ item.memo }}
													</td>
													<td>
														<span
															:class="
																item.status
																	? 'badge bg-success mr-1'
																	: 'badge bg-danger mr-1'
															"
														></span>
														{{ item.status ? "已完成" : "未完成" }}
													</td>
													<td>{{ item.createdAt }}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="card-footer">
										<div class="row">
											<div class="col-12">
												<ul class="pagination m-0 ms-auto float-right">
													<li
														class="page-item"
														:class="{ disabled: pagination.currentPage === 1 }"
													>
														<a
															class="page-link"
															href="#"
															@click.prevent="
																getWithdrawalList(
																	order,
																	sort,
																	pagination.currentPage - 1,
																	size,
																)
															"
														>
															&laquo; Prev
														</a>
													</li>
													<li
														class="page-item"
														v-for="page in pagination.totalPageCount"
														:key="page"
														:class="{ active: pagination.currentPage === page }"
													>
														<a
															class="page-link"
															href="#"
															@click.prevent="
																getWithdrawalList(
																	order,
																	sort,
																	page,
																	size,
																)
															"
															>{{ page }}</a
														>
													</li>
													<li
														class="page-item"
														:class="{
															disabled:
																pagination.currentPage === pagination.totalPageCount,
														}"
													>
														<a
															class="page-link"
															href="#"
															@click.prevent="
																getWithdrawalList(
																	order,
																	sort,
																	pagination.currentPage + 1,
																	size,
																)
															"
														>
															Next &raquo;
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
      </div>
      <div class="col-md-1"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      token: "",
      alertMsg: "",
      alertStatus: "",
      assets: [],
      withdrawalList: [],
      order: "",
      sort: "",
      page: 1,
      size: 10,
      tronUSDTremainBalance: 0,
      ethereumUSDTremainBalance: 0,
      pagination: {
        totalPageCount: 0,
        currentPage: 0,
        total: 0,
      },
    };
  },
  methods: {
    getWithdrawalList(
      order = "amount",
      sort = "desc",
      page = 1,
      size = 10,
    ) {
      let api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/customerWithdrawal?order=${order}&sort=${sort}&size=${size}&page=${page}`;
      this.order = order;
      this.sort = sort;
      this.size = size;
      this.page = page;
      const vm = this;

      this.$http
        .get(api, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then(function(res) {
          if (res.data.status === "success") {
            vm.withdrawalList = res.data.data;
            vm.pagination.currentPage = res.data.page;
            vm.pagination.total = res.data.total;
            vm.pagination.totalPageCount = Math.ceil(res.data.total / vm.size);
          }
        });
    },
    changeSize() {
      this.getWithdrawalList(
        this.order,
        this.sort,
        this.page,
        this.size,
      );
    },
    getRemainBalance(paymentProtocol) {
      let api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/getRemainBalance/${paymentProtocol}`;
      const vm = this;

      this.$http
        .get(api, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then(function(res) {
          if (res.data.status === "success") {
            if (paymentProtocol === 'tronUSDT') {
              vm.tronUSDTremainBalance = res.data.data;
            } else if (paymentProtocol === 'ethereumUSDT') {
              vm.ethereumUSDTremainBalance = res.data.data;
            }
          }
        });
    }
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getWithdrawalList();
    this.getRemainBalance('tronUSDT');
    this.getRemainBalance('ethereumUSDT');
  },
};
</script>
